"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingPathKeys = void 0;
var ExistingPathKeys;
(function (ExistingPathKeys) {
    ExistingPathKeys.extensionIdKey = 'extensionId';
    ExistingPathKeys.pathKey = 'path';
})(ExistingPathKeys || (exports.ExistingPathKeys = ExistingPathKeys = {}));
//# sourceMappingURL=IExtensionContext.js.map